(function (Drupal, $) {
  Drupal.behaviors.denMenuViewForm = {
    attach: function attach(context) {
      $('#den-menu__view__styled-form', context).each(function () {
        // Category Filter
        $('.js--den-menu__category__option').on('click', function(){
          $('.js--den-menu__category__option').removeClass('clicked');
          $('[data-drupal-selector="edit-field-dmi-category-target-id"]').val($(this).data('value'));
          $(this).addClass('clicked');
          $('.form-actions input').click();
        });
        $('[data-drupal-selector="edit-field-dmi-category-target-id"]').on('change', function (){
          console.log('Clicked a selection');
          $('.form-actions input').click();
        });
      });
    }
  }
})(Drupal, jQuery);
